import { useState } from "react";
import { Link } from "react-router-dom";
import { endpoints, formatApiError } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function Forgot() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");
    const [devLink, setDevLink] = useState(null);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError("");
        try {
            const d = await endpoints.authForgot(email);
            setSent(true);
            if (d.dev_reset_link) setDevLink(d.dev_reset_link);
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="max-w-md mx-auto px-4 md:px-6 py-16" data-testid="forgot-page">
            <div className="border border-[#2a2a2a] p-8">
                <div className="text-[10px] font-mono uppercase tracking-widest text-[#ff4400]">Project Mint</div>
                <h1 className="mt-2 font-display font-black uppercase tracking-tighter text-3xl">Reset password</h1>
                <p className="mt-3 text-sm text-[#a3a3a3]">Enter your email — we'll send a reset link (dev mode returns the link directly).</p>

                {sent ? (
                    <div className="mt-6 border border-[#2a2a2a] p-4 text-sm" data-testid="forgot-sent">
                        <div className="text-[10px] font-mono uppercase text-[#00e676]">Sent</div>
                        <div className="mt-1 text-[#a3a3a3]">If an account exists for <span className="text-[#f4f4f0]">{email}</span>, a reset link has been prepared.</div>
                        {devLink && (
                            <div className="mt-3">
                                <div className="text-[10px] font-mono uppercase text-[#666]">Dev reset link</div>
                                <Link to={devLink} className="text-xs font-mono text-[#ff4400] break-all" data-testid="forgot-dev-link">{devLink}</Link>
                            </div>
                        )}
                    </div>
                ) : (
                    <form onSubmit={submit} className="mt-6 space-y-4">
                        <label className="block">
                            <span className="text-[10px] font-mono uppercase tracking-widest text-[#a3a3a3]">Email</span>
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-1 bg-transparent border-b border-[#2a2a2a] focus:border-[#ff4400] py-2 outline-none" data-testid="forgot-email" />
                        </label>
                        {error && <div className="text-xs font-mono uppercase text-[#ff3333]" data-testid="forgot-error">{error}</div>}
                        <button type="submit" disabled={busy || !email} className="pm-btn pm-btn-primary w-full" data-testid="forgot-submit">
                            {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
                            Send reset link
                        </button>
                    </form>
                )}

                <div className="mt-6 text-center text-xs font-mono uppercase">
                    <Link to="/signin" className="text-[#a3a3a3] hover:text-[#ff4400]" data-testid="forgot-back-link">← Back to sign in</Link>
                </div>
            </div>
        </div>
    );
}
